import { render, staticRenderFns } from "./WhitePart.vue?vue&type=template&id=e354da98&scoped=true&"
import script from "./WhitePart.vue?vue&type=script&lang=js&"
export * from "./WhitePart.vue?vue&type=script&lang=js&"
import style0 from "./WhitePart.vue?vue&type=style&index=0&id=e354da98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e354da98",
  null
  
)

export default component.exports